import {gql} from '@apollo/client';

export const CREATE_REG = gql`
    mutation createGetMoneyWwReg ($data: GetMoneyWwRegInput!, $session: String) {
        createGetMoneyWwReg(data: $data, session: $session) {
            data {
                id
            }
        }
    }
`